import { ChevronRight } from "lucide-react";
import { type ReactNode, useState } from "react";

import { cn } from "@/lib/utils";

/** Bloc replié de la fiche : son contenu n'est construit qu'à l'ouverture (l'équipe d'une société compte jusqu'à
 * 150 personnes, chacune avec ses recherches). */
export const Fold = ({
  summary,
  children,
  defaultOpen = false,
  className,
  summaryClassName,
  openOnJump = false,
}: {
  summary: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
  className?: string;
  summaryClassName?: string;
  // Ouvert quand on saute au bloc qui le contient (lien de la synthèse).
  openOnJump?: boolean;
}) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <details
      open={open}
      onToggle={(event) => setOpen(event.currentTarget.open)}
      className={cn("group", className)}
      data-open-on-jump={openOnJump || undefined}
    >
      <summary
        className={cn(
          "flex w-fit cursor-pointer list-none items-center gap-1 rounded-[3px] text-xs text-muted-foreground hover:text-foreground [&::-webkit-details-marker]:hidden",
          summaryClassName,
        )}
      >
        <ChevronRight
          className="size-3.5 shrink-0 transition-transform group-open:rotate-90"
          aria-hidden
        />
        {summary}
      </summary>
      {open && children}
    </details>
  );
};
